<template>
  <div class="app-container">
    <div class="title-row"><span class="title">{{ titleName }}</span></div>
    <el-form :model="queryParams" ref="queryForm" :inline="true" size="small" v-show="showSearch" label-width="68px">
      <el-form-item label="所属线路" prop="lineCode">
        <el-select v-model="queryParams.lineCode" @change="changeLine">
          <el-option v-for="item in lineOptions" :key="item.lineCode" :label="item.lineName" :value="item.lineCode"/>
        </el-select>
      </el-form-item>
      <el-form-item label="站点名称" prop="stationName">
        <el-input v-model="queryParams.stationName" placeholder="请输入站点名称" clearable @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="站点状态" prop="stationStatus" >
        <el-select v-model="queryParams.stationStatus" placeholder="站点状态" @change="handleQuery" clearable >
          <el-option v-for="dict in dict.type.metro_status" :key="dict.value" :label="dict.label" :value="dict.value"/>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button v-hasPermi="['metro:station:add']" type="primary" plain icon="el-icon-plus" size="mini" @click="handleAdd" >新增</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList" ></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="stationList" style="width: 100%" border >
      <el-table-column type="index" label="序号" align="center" width="60"/>
      <el-table-column label="站点名称" align="center" prop="stationName" min-width="120"/>
      <el-table-column label="运营状态" align="center" prop="stationStatus" min-width="90">
        <template slot-scope="scope">
          <el-switch
              v-if="$auth.hasPermiOr(['metro:station:add','metro:station:edit'])"
              v-model="scope.row.stationStatus"
              active-value="1"
              inactive-value="0"
              active-color="#13ce66"
              @change="handleStatusChange(scope.row)"
          ></el-switch>
          <dict-tag v-else :options="dict.type.metro_status" :value="scope.row.stationStatus"/>
        </template>
      </el-table-column>
      <el-table-column label="排序" align="center" prop="orderNum" min-width="60"/>
      <el-table-column label="备注" align="center" prop="remark" min-width="180"/>
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="120">
        <template slot-scope="scope">
          <el-button v-hasPermi="['metro:station:edit']" size="mini" type="text" icon="el-icon-edit" @click="handleUpdate(scope.row)" >修改</el-button>
          <el-button v-hasPermi="['metro:station:remove']" size="mini" type="text" icon="el-icon-delete" @click="handleDelete(scope.row)" >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加或修改轨道交通站点对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="600px" :close-on-click-modal="false"  append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="所属线路" prop="lineCode" >
              <el-select v-model="form.lineCode" :disabled="lineCodeDisabled">
                <el-option v-for="item in lineOptions" :key="item.lineCode" :label="item.lineName" :value="item.lineCode"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="站点名称" prop="stationName">
              <el-input v-model="form.stationName" placeholder="请输入站点名称" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="站点状态" prop="stationStatus">
              <el-radio-group v-model="form.stationStatus">
                <el-radio
                    v-for="dict in dict.type.metro_status"
                    :key="dict.value"
                    :label="dict.value"
                >{{dict.label}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序" prop="orderNum">
              <el-input-number :min="1" v-model="form.orderNum" placeholder="请输入排序" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="form.remark" type="textarea" placeholder="请输入内容" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listStation, getStation, delStation, addStation, updateStation,updateStatus } from "@/api/metro/station"
import {getLine, lineSelect} from "@/api/metro/line"

export default {
  name: "MetroStation",
  dicts:['metro_status'],
  data() {
    return {
      titleName: "",
      // 遮罩层
      loading: true,
      showSearch:true,
      // 总条数
      total: 0,
      // 轨道交通站点表格数据
      stationList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        stationName: null,
        lineCode: null,
        stationStatus: null,
        orderNum: null,
      },
      pathParams:{
        lineCode: null,
        metroName: null,
      },
      lineOptions: [],
      lineCodeDisabled: false,
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        stationName: [
          { required: true, message: "站点名称不能为空", trigger: "blur" }
        ],
        lineCode: [
          { required: true, message: "所属线路不能为空", trigger: "blur" }
        ],
        stationStatus: [
          { required: true, message: "运营状态不能为空", trigger: "blur" }
        ],
        orderNum: [
          { required: true, message: "排序不能为空", trigger: "blur" }
        ],
      }
    }
  },
  created() {
    const lineId = this.$route.query.lineId
    getLine(lineId).then(res=>{
      if(res.code===20000){
        this.pathParams.lineCode = res.data.lineCode
        this.pathParams.metroName = res.data.metroName
        this.titleName = res.data.metroName + " - " + res.data.lineName+ " - 站点管理"
        this.getLineSelect(res.data.metroCode,res.data.lineCode)
      }
    })

  },
  methods: {
    getLineSelect(metroCode,linCode){
      lineSelect(metroCode).then(res=>{
        if(res.code===20000){
          this.lineOptions = res.data
          this.queryParams.lineCode = linCode
          this.getList()
        }
      })
    },
    changeLine(item){
      const line = this.lineOptions.find(obj=>obj.lineCode===item)
      this.titleName = this.pathParams.metroName + " - " + line.lineName + " - " + "站点管理"
      this.getList()
    },
    /** 查询轨道交通站点列表 */
    getList() {
      this.loading = true
      listStation(this.queryParams).then(response => {
        this.stationList = response.data
        this.total = response.data.length
        this.loading = false
      })
    },
    // 站点状态修改
    handleStatusChange(row) {
      let text = row.stationStatus === "0" ? "未运营" : "运营中";
      this.$modal.confirm('确认要将【'+row.stationName+'】设置为"' + text + '"吗？').then(function() {
        return updateStatus(row.stationId, row.stationStatus);
      }).then(() => {
        this.$modal.msgSuccess("设置"+text + "成功");
      }).catch(function() {
        row.stationStatus = row.stationStatus === "0" ? "1" : "0";
      });
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        stationId: null,
        stationName: null,
        lineCode: this.pathParams.lineCode,
        stationStatus: "0",
        orderNum: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        remark: null
      }
      this.resetForm("form")
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm")
      this.queryParams.lineCode = this.pathParams.lineCode
      this.handleQuery()
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.lineCodeDisabled = false
      this.open = true
      this.title = "添加轨道交通站点"
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset()
      this.lineCodeDisabled = true
      const stationId = row.stationId
      getStation(stationId).then(response => {
        this.form = response.data
        this.open = true
        this.title = "修改轨道交通站点"
      })
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.stationId != null) {
            updateStation(this.form).then(response => {
              this.$modal.msgSuccess("修改成功")
              this.open = false
              this.getList()
            })
          } else {
            addStation(this.form).then(response => {
              this.$modal.msgSuccess("新增成功")
              this.open = false
              this.getList()
            })
          }
        }
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      this.$modal.confirm('是否确认删除轨道交通站点名称为"' + row.stationName + '"的数据项？').then(function() {
        return delStation(row.stationId)
      }).then(() => {
        this.getList()
        this.$modal.msgSuccess("删除成功")
      }).catch(() => {})
    }
  }
}
</script>
